import _ from 'lodash'

function Debounce (delay: number) {
  return (target: any, prop: string) => {
    return {
      configurable: true,
      enumerable: false,
      value: _.debounce(target[prop], delay)
    }
  }
}

export { Debounce }
